import { Storage } from 'aws-amplify';
function put(directoryString, file, progressCallback) {
    const config = {
        level: 'private',
        contentType: 'image/png',
        progressCallback,
    };
    return Storage.put(directoryString + file.name, file, config);
}
const getObject = (key) => {
    const config = {
        level: 'private',
        download: false,
    };
    return Storage.get(key, config);
};
const listObjects = (path) => {
    let res;
    try {
        const config = {
            level: 'private',
        };
        res = Storage.list(path, config);
    }
    catch (e) {
        console.log('caught', e.message);
        res = Promise.resolve({ hasNextToken: false, results: [] });
    }
    return res;
};
const listObjectsAndUrls = async (path) => {
    const metaUrlList = {};
    await listObjects(path).then(async (imageMetas) => {
        const promised = await Promise.all(imageMetas.results.map(async (imageMeta) => {
            let url = '';
            if (imageMeta.key) {
                url = await getObject(imageMeta.key);
            }
            return { url, ...imageMeta };
        }));
        promised.forEach((item) => {
            if (typeof item.url === 'string') {
                const key = item.key;
                if (key) {
                    metaUrlList[key] = item;
                }
            }
        });
    });
    return metaUrlList;
};
const deleteObject = (key) => {
    const config = {
        level: 'private',
    };
    return Storage.remove(key, config);
};
const getImageUrl = async (businessObject, publicImage = false) => {
    let presignedUrl = undefined;
    if (businessObject) {
        const imageKey = businessObject.primaryS3Image?.key;
        if (imageKey) {
            presignedUrl = publicImage ? await getPublicObject(imageKey) : await getObject(imageKey);
        }
    }
    return presignedUrl;
};
// WARN: These two methods put things into the buckets publically and should not be the default
function putPublic(directoryString, file, progressCallback) {
    const config = {
        level: 'public',
        contentType: 'image/png',
        progressCallback,
    };
    return Storage.put(directoryString + file.name, file, config);
}
const getPublicObject = (key) => {
    const config = {
        level: 'public',
        download: false,
    };
    return Storage.get(key, config);
};
const deletePublicObject = (key) => {
    const config = {
        level: 'public',
    };
    return Storage.remove(key, config);
};
const listPublicObjects = (path) => {
    let res;
    try {
        const config = {
            level: 'public',
        };
        res = Storage.list(path, config);
    }
    catch (e) {
        console.log('caught', e.message);
        res = Promise.resolve({ hasNextToken: false, results: [] });
    }
    return res;
};
const listPublicObjectsAndUrls = async (path) => {
    const metaUrlList = {};
    await listPublicObjects(path).then(async (imageMetas) => {
        const promised = await Promise.all(imageMetas.results.map(async (imageMeta) => {
            let url = '';
            if (imageMeta.key) {
                url = await getPublicObject(imageMeta.key);
            }
            return { url, ...imageMeta };
        }));
        promised.forEach((item) => {
            if (typeof item.url === 'string') {
                const key = item.key;
                if (key) {
                    metaUrlList[key] = item;
                }
            }
        });
    });
    return metaUrlList;
};
export { deleteObject, deletePublicObject, getImageUrl, getObject, getPublicObject, listObjects, listObjectsAndUrls, listPublicObjects, listPublicObjectsAndUrls, put, putPublic, };
